import type { FaireProductEntity } from "../../entity_types/product";

export const p_cejevzfng5: FaireProductEntity = {
  token: "p_cejevzfng5",
  type: "product",
  name: "EVA Beach Bag Tote for Women, Waterproof Sandproof Lightweight Diy Charm Handbag",
  brandToken: "b_mjd9qy3dnh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/def3869270039b0216c44360d21e2c5a5f9c61cc8fb1520d188ece183edff884.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9136c141023a1b33be4e11d6ebddcc6a221834ded8e3f2c2eba021104b3152e1.jpeg",
    "https://cdn.faire.com/fastly/1522aeb2010fb2b076c0e7727f2a5c48d8d050cf052af928675f467c91b5cdd9.jpeg",
    "https://cdn.faire.com/fastly/21a7156684555e0b5dd03e8f171516659e75efc170e15e464ccff0089d041394.jpeg",
    "https://cdn.faire.com/fastly/095d16d3679798499bb1742bead3e03c9d1ece5f493ffe20940d73dc875a0478.jpeg",
    "https://cdn.faire.com/fastly/68173703875c70d51f91fe862a688a3d0ec908ce84cdd70d8d5cbe20d54014ba.jpeg",
    "https://cdn.faire.com/fastly/15e6c9679e5d2decb1f5d29f7e0658a48baaa78416c50cd9dbb25915e0e14fc8.jpeg",
    "https://cdn.faire.com/fastly/f6cc3d236119b3b98f6f4147cd6af6248d9d9d56614ac7002315666503ea8fb4.jpeg",
    "https://cdn.faire.com/fastly/6886e30496e01943d5e46d41f9165afdd11e107194217931bed5e5d74be683e4.jpeg",
  ],
  priceDollars: 27.7,
  description:
    "Convertible Handbag & Shoulder Bag: Foldable handle adjusts for compact storage or upright carrying. Reinforced straps ensure comfort even when fully loaded.\nExclusive Design-Patented Aesthetic: Features a unique patented shape and streamlined silhouette, combining fashion with functionality—stand out at the beach or in the city.\nWaterproof & Sand-Proof EVA Material: Lightweight yet durable, resists spills, odors, and sand. Rinse clean in seconds after outdoor activities.\nDIY Customization: Choose from shades to match your style. Personalize further with charms on the multi-hole design.\nMulti-Scene Versatility: Ideal for travel, gym, pool days, or daily errands. Compact 10.9”x8.5”x3” size fits essentials without bulk.\n",
  tags: [],
  msrpDollars: 55.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:21.627Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
